import { FooterModel } from './footer.model';
import { TextStyleModel } from '../../PageBuilder/models/text-style.model';
import { DistributionStyleStateEnum } from '../enum/distribution-style-state.enum';
import { StyleStateEnum } from '../../PageBuilder/enums/style-state.enum';
import { RichTextDisplayElementModel } from '../../PageBuilder/models/rich-text-display-element.model';
import { DropdownOptionModel } from '../../Forms/models/dropdown-option.model';
import { footerUnsubLanguagesToUnsubString } from '../enum/footer-unsub-languages.emum';

const emptyLinesAndHTMLElements = /(\n)|(<(div|p|span|ul|ol)[^>]*>(\s|&nbsp;|<\/?\s?br\s?\/?>)*<\/?(div|p|span|ul|ol)>)/g;

export class FooterDisplayElementModel extends RichTextDisplayElementModel {
    renderedText: string;
    htmlEdit: boolean = false;
    enableHtmlEditor = false;
    enablePersonalizations = true;
    mergeTagOptions = [
        new DropdownOptionModel('Address Pre Text', '[%ADDRESS_PRE_TEXT%]'),
        new DropdownOptionModel('Company Organization', '[%COMPANY_ORGANIZATION%]'),
        new DropdownOptionModel('Street Address', '[%STREET_ADDRESS%]'),
        new DropdownOptionModel('City', '[%CITY%]'),
        new DropdownOptionModel('State Province', '[%STATE_PROVINCE%]'),
        new DropdownOptionModel('Zip Postal Code', '[%ZIP_POSTAL_CODE%]'),
        new DropdownOptionModel('Country', '[%COUNTRY%]'),
        new DropdownOptionModel('Contact Information', '[%CONTACT_INFORMATION%]'),
        new DropdownOptionModel('Unsubscribe', '[%UNSUBSCRIBE%]')
    ];
    footer: FooterModel;

    constructor(
        footer?: FooterModel,
        styles?: any
    ) {
        super();

        this.footer = footer;
        this.styles = styles && styles.clone ? styles.clone() : new TextStyleModel(styles);
        if (!this.styles.styleState || this.styles.styleState === StyleStateEnum.DEFAULT) {
            this.styles.styleState = DistributionStyleStateEnum.DISTRIBUTION_1;
        }

        if (!this.styles.displayStyleState || this.styles.displayStyleState === StyleStateEnum.DEFAULT) {
            this.styles.displayStyleState = DistributionStyleStateEnum.DISTRIBUTION_1;
        }

        this.text = footer.text;
        this.isBoundToGlobalStyles = true;
        this.updateRenderedText();
    }

    canRender(): boolean {
        if (!this.text) {
            this.text = ' ';
        }
        this.updateRenderedText();
        this.footer.text = this.text;
        return true;
    }

    clone(): FooterDisplayElementModel {
        // TODO : implement properly (needed?)
        return new FooterDisplayElementModel(this.footer.clone(), this.styles.clone());
    }

    onUpdate(): boolean {
        return true;
    }

    isEqual(other: FooterDisplayElementModel): boolean {
        if (!other) {
            return false;
        }

        if (!other.footer || !this.footer.equals(other.footer)) {
            return false;
        }
        if (this.text !== other.text) {
            return false;
        }
        if (!this.styles.equals(other.styles, false)) {
            return false;
        }
        if (this.isBoundToGlobalStyles !== other.isBoundToGlobalStyles) {
            return false;
        }
        if (this.htmlEdit !== other.htmlEdit) {
            return false;
        }
        if (this.editorDirty !== other.editorDirty) {
            return false;
        }

        return true;
    }

    updateRenderedText(hideOptionalMergeTags: boolean = false): void {
        this.renderedText = this.text;

        if (this.footer.addressPreText?.trim()) {
            this.renderedText = this.renderedText.replace(/\[%ADDRESS_PRE_TEXT%\]/g, this.footer.addressPreText);
        } else if (hideOptionalMergeTags) {
            this.renderedText = this.renderedText.replace(/\[%ADDRESS_PRE_TEXT%\]/g, '');
        }
        if (this.footer.company?.trim()) {
            this.renderedText = this.renderedText.replace(/\[%COMPANY_ORGANIZATION%\]/g, this.footer.company);
        }
        if (this.footer.streetAddress?.trim()) {
            this.renderedText = this.renderedText.replace(/\[%STREET_ADDRESS%\]/g, this.footer.streetAddress);
        }
        if (this.footer.city?.trim()) {
            this.renderedText = this.renderedText.replace(/\[%CITY%\]/g, this.footer.city);
        }
        if (this.footer.province?.trim()) {
            this.renderedText = this.renderedText.replace(/\[%STATE_PROVINCE%\]/g, this.footer.province);
        } else if (hideOptionalMergeTags) {
            this.renderedText = this.renderedText.replace(/\[%STATE_PROVINCE%\],?/g, '');
        }

        if (this.footer.postalCode?.trim()) {
            this.renderedText = this.renderedText.replace(/\[%ZIP_POSTAL_CODE%\]/g, this.footer.postalCode);
        }
        if (this.footer.country?.trim()) {
            this.renderedText = this.renderedText.replace(/\[%COUNTRY%\]/g, this.footer.country);
        }

        if (this.footer.senderEmail?.trim()) {
            this.renderedText = this.renderedText.replace(/\[%CONTACT_INFORMATION%\]/g, this.footer.senderEmail);
        } else if (this.footer.senderPhone?.trim()) {
            this.renderedText = this.renderedText.replace(/\[%CONTACT_INFORMATION%\]/g, this.footer.senderPhone);
        }

        if (this.footer.unsubLinkLanguage) {
            // eslint-disable-next-line max-len
            const renderedLink = `<a href="${this.footer.unsubLink}" style="color: inherit;" target="_blank";">${footerUnsubLanguagesToUnsubString.get(this.footer.unsubLinkLanguage)}</a>`;

            this.renderedText = this.renderedText.replace(/\[%UNSUBSCRIBE%\]/g,
                renderedLink
            );
        }
    }
}
